import Vue from 'vue';
// import 'element-plus/dist/index.css';
import './assets/css/base.less';
import './assets/css/index.less';
import { http, omsMainServer } from '@/utils/http';
import api from '@/api';
import App from './App.vue';
import router from './router';
import store from './store';
import { sendMonitorData } from './utils/sendMonitorData';

import './utils/installAntdv';

Vue.config.productionTip = false;


Vue.prototype.$http = http;
Vue.prototype.$api = api;

sendMonitorData(store, http);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
